import instance from '../utils/axios';

class SwitchService {

    async getList() {
        return await instance.post('/crm/crm/contact/getNotificationStatusList');
    }

    async changeStatus(uuid) {
        return await instance.post('/crm/crm/contact/updateNotificationStatus',{uuid:uuid});
    }
}

export default new SwitchService();